import { Card, Flex, Text, Icon, iconWeight } from '@nula/core-ui';
import { getEntityKindMeta } from '@/utils/entity-kind-meta';
import { useLiveRecording } from '@/lib/recordings/use-live-recording';
import { RecordingDot } from '@/components/recording-dot/recording-dot';
import styles from './home.module.css';

interface HomeRecentCardProps {
  id: string;
  title: string;
  updatedAt: string;
  kind: string;
  color: string;
  onClick: () => void;
}

/**
 * A recent-entity card on the Home view: kind label, title, and date. Shows a
 * recording dot beside the title while the entity is actively being recorded.
 */
export function HomeRecentCard({ id, title, updatedAt, kind, color, onClick }: HomeRecentCardProps) {
  const meta = getEntityKindMeta(kind);
  const isRecording = useLiveRecording(id)?.phase === 'capturing';

  return (
    <Card hoverable onClick={onClick} className={styles.docCard}>
      <Flex vertical gap="sm">
        {/* Type label — color carries the kind (no top accent border) */}
        <Flex align="center" gap="xs" className={styles.docType} style={{ '--card-accent-color': color } as React.CSSProperties}>
          <Icon name={meta.icon} size={14} weight={iconWeight.light} className={styles.docTypeIcon} />
          <Text size="xs" className={styles.docTypeMeta}>
            {meta.label}
          </Text>
        </Flex>

        {/* Title */}
        <Flex align="center" gap="xs">
          <Text className={styles.docTitle}>
            {title}
          </Text>
          {isRecording && <RecordingDot />}
        </Flex>

        {/* Date */}
        <Text size="sm" className={styles.docDate}>
          {updatedAt}
        </Text>
      </Flex>
    </Card>
  );
}
